import {createContext} from 'react'

export const CustomerChurnContext = createContext<any>({
  customers: [],
  isLoading: false,
  onSearch: () => {},
  onSortingChange: () => {},
  onPageChange: () => {},
})
